(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
// Go to corresponding slide on Shopify's editor
document.addEventListener('shopify:block:select', (e) => {
    const carouselEl = e.target.closest('.carousel')

    if (carouselEl) {
        const selectedSlide = e.target.dataset.index
        bootstrap.Carousel.getOrCreateInstance(carouselEl, { interval: false }).to(selectedSlide)
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
// Go to corresponding slide on Shopify's editor
document.addEventListener('shopify:block:select', (e) => {
    const carouselEl = e.target.closest('.carousel')

    if (carouselEl) {
        const selectedSlide = e.target.dataset.index
        bootstrap.Carousel.getOrCreateInstance(carouselEl, { interval: false }).to(selectedSlide)
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-carousel"] && !Shopify.designMode) return;
  try {
    
  // Go to corresponding slide on Shopify's editor
  document.addEventListener('shopify:block:select', (e) => {
    const carouselEl = e.target.closest('.carousel');

    if (carouselEl) {
      const selectedSlide = e.target.dataset.index;
      bootstrap.Carousel.getOrCreateInstance(carouselEl, { interval: false }).to(selectedSlide);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
